import { computed, getCurrentInstance } from '@vue/composition-api';

const useMovedOrDeletedInfo = (props) => {
  const { emit } = getCurrentInstance();

  const restoreText = computed(() => (props?.isMoved ? 'Оставить в корзине' : 'Восстановить'));

  const titleText = computed(() => {
    let title = 'Вы удалили из корзины:';

    if (props?.isMoved) {
      title = 'Вы переложили в «Отложенные товары»:';
    }
    return title;
  });

  const handlerSplice = () => {
    emit('spliceItem');
  };
  const handlerRestore = () => {
    emit('restoreItem');
  };

  return {
    restoreText,
    titleText,
    handlerSplice,
    handlerRestore,
  };
};

export default useMovedOrDeletedInfo;
